import AppProvider, { useApp } from './App.provider';

export { useApp };

export default AppProvider;
